// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-bubble {
	border: 1px solid #303030;
	border-radius: 8px;
}

.ql-editor {
    font-size: 16px !important;
}

.ant-segmented-group {
	display: inline-flex;
	flex-wrap: wrap;
	flex-direction: row;
}

.ql-container.ql-snow,
.ql-container.ql-bubble {
	border: 0px solid #303030;
	border-radius: 8px;
	/* overflow-y: auto;
    max-height: 1000px; */
}

.ql-toolbar.ql-snow {
	border: 0px solid #303030;
	border-radius: 8px;
}

.ql-editor p {
	margin: 12px 0 !important;
	font-family: 'Inter';
}

.ql-editor {
	line-height: 1.5 !important;
}

.ql-editor li {
	margin: 12px 0 !important;
	font-family: 'Inter';
}

.ql-editor h1,
h2,
h3,
h4,
h5 {
	font-family: 'Inter';
}

.ql-container {
	font-size: 16px !important;
}

.ql-smart-field {
	border-radius: 4px;
	background-color: rgba(0, 97, 0, 0);
}

table.quill-better-table td {
	border: 1px solid #444;
}
.ql-clipboard {
	position: fixed;
	display: none;
	left: 50%;
	top: 50%;
}

table.quill-better-table td {
	border: 1px solid #cccccc;
	background-color: #fafafa;
}

.ql-clipboard {
	position: fixed;
	display: none;
	left: 50%;
	top: 50%;
}

[class^='placeholderClass'],
[class^='dateClass'],
[class^='fullnameClass'],
[class^='emailClass'],
[class^='signClass'],
[class^='initialsClass'] {
	border-radius: 4px;
	border: 1px solid #d0e0c7;
	color: black;
}

.ant-space-item:has(> #contractActionsFooter) {
	bottom: 8px;
	position: sticky;
	z-index: 1000;
}

.qlbt-operation-menu {
	z-index: 2001 !important;
}

.ql-container {
	box-sizing: border-box;
	font-family: Helvetica, Arial, sans-serif;
	font-size: 13px;
	height: 100%;
	margin: 0;
	position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
	visibility: hidden;
}
.ql-container:not(.ql-disabled) li[data-list='checked'] > .ql-ui,
.ql-container:not(.ql-disabled) li[data-list='unchecked'] > .ql-ui {
	cursor: pointer;
}
.ql-clipboard {
	left: -100000px;
	height: 1px;
	overflow-y: hidden;
	position: absolute;
	top: 50%;
}
.ql-clipboard p {
	margin: 0;
	padding: 0;
}
.ql-editor {
	box-sizing: border-box;
	counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
		list-9;
	line-height: 1.42;
	height: 100%;
	outline: none;
	overflow-y: auto;
	padding: 12px 15px;
	tab-size: 4;
	-moz-tab-size: 4;
	text-align: left;
	white-space: pre-wrap;
	word-wrap: break-word;
}
.ql-editor > * {
	cursor: text;
	white-space: pre-wrap;
}
.ql-editor p,
.ql-editor ol,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
	margin: 0;
	padding: 0;
}

@supports (counter-set: none) {
	.ql-editor p,
	.ql-editor h1,
	.ql-editor h2,
	.ql-editor h3,
	.ql-editor h4,
	.ql-editor h5,
	.ql-editor h6 {
		counter-set: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
			list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor p,
	.ql-editor h1,
	.ql-editor h2,
	.ql-editor h3,
	.ql-editor h4,
	.ql-editor h5,
	.ql-editor h6 {
		counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7
			list-8 list-9;
	}
}
.ql-editor table {
	border-collapse: collapse;
}
.ql-editor td {
	border: 1px solid #000;
	padding: 2px 5px;
}
.ql-editor ol {
	padding-left: 1.5em;
}
.ql-editor li {
	list-style-type: none;
	padding-left: 1.5em;
	position: relative;
}
.ql-editor li > .ql-ui:before {
	display: inline-block;
	margin-left: -1.5em;
	margin-right: 0.3em;
	text-align: right;
	white-space: nowrap;
	width: 1.2em;
}
.ql-editor li[data-list='checked'] > .ql-ui,
.ql-editor li[data-list='unchecked'] > .ql-ui {
	color: #777;
}
.ql-editor li[data-list='bullet'] > .ql-ui:before {
	content: '\\2022';
}
.ql-editor li[data-list='checked'] > .ql-ui:before {
	content: '\\2611';
}
.ql-editor li[data-list='unchecked'] > .ql-ui:before {
	content: '\\2610';
}
@supports (counter-set: none) {
	.ql-editor li[data-list] {
		counter-set: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list] {
		counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
			list-9;
	}
}
.ql-editor li[data-list='ordered'] {
	counter-increment: list-0;
}
.ql-editor li[data-list='ordered'] > .ql-ui:before {
	content: counter(list-0, decimal) '. ';
}
.ql-editor li[data-list='ordered'].ql-indent-1 {
	counter-increment: list-1;
}
.ql-editor li[data-list='ordered'].ql-indent-1 > .ql-ui:before {
	content: counter(list-1, lower-alpha) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-1 {
		counter-set: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-1 {
		counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-2 {
	counter-increment: list-2;
}
.ql-editor li[data-list='ordered'].ql-indent-2 > .ql-ui:before {
	content: counter(list-2, lower-roman) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-2 {
		counter-set: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-2 {
		counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-3 {
	counter-increment: list-3;
}
.ql-editor li[data-list='ordered'].ql-indent-3 > .ql-ui:before {
	content: counter(list-3, decimal) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-3 {
		counter-set: list-4 list-5 list-6 list-7 list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-3 {
		counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-4 {
	counter-increment: list-4;
}
.ql-editor li[data-list='ordered'].ql-indent-4 > .ql-ui:before {
	content: counter(list-4, lower-alpha) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-4 {
		counter-set: list-5 list-6 list-7 list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-4 {
		counter-reset: list-5 list-6 list-7 list-8 list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-5 {
	counter-increment: list-5;
}
.ql-editor li[data-list='ordered'].ql-indent-5 > .ql-ui:before {
	content: counter(list-5, lower-roman) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-5 {
		counter-set: list-6 list-7 list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-5 {
		counter-reset: list-6 list-7 list-8 list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-6 {
	counter-increment: list-6;
}
.ql-editor li[data-list='ordered'].ql-indent-6 > .ql-ui:before {
	content: counter(list-6, decimal) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-6 {
		counter-set: list-7 list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-6 {
		counter-reset: list-7 list-8 list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-7 {
	counter-increment: list-7;
}
.ql-editor li[data-list='ordered'].ql-indent-7 > .ql-ui:before {
	content: counter(list-7, lower-alpha) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-7 {
		counter-set: list-8 list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-7 {
		counter-reset: list-8 list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-8 {
	counter-increment: list-8;
}
.ql-editor li[data-list='ordered'].ql-indent-8 > .ql-ui:before {
	content: counter(list-8, lower-roman) '. ';
}
@supports (counter-set: none) {
	.ql-editor li[data-list].ql-indent-8 {
		counter-set: list-9;
	}
}
@supports not (counter-set: none) {
	.ql-editor li[data-list].ql-indent-8 {
		counter-reset: list-9;
	}
}
.ql-editor li[data-list='ordered'].ql-indent-9 {
	counter-increment: list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-9 > .ql-ui:before {
	content: counter(list-9, decimal) '. ';
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
	padding-left: 3em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
	padding-left: 4.5em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
	padding-right: 3em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
	padding-right: 4.5em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
	padding-left: 6em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
	padding-left: 7.5em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
	padding-right: 6em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
	padding-right: 7.5em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
	padding-left: 9em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
	padding-left: 10.5em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
	padding-right: 9em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
	padding-right: 10.5em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
	padding-left: 12em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
	padding-left: 13.5em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
	padding-right: 12em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
	padding-right: 13.5em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
	padding-left: 15em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
	padding-left: 16.5em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
	padding-right: 15em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
	padding-right: 16.5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
	padding-left: 18em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
	padding-left: 19.5em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
	padding-right: 18em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
	padding-right: 19.5em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
	padding-left: 21em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
	padding-left: 22.5em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
	padding-right: 21em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
	padding-right: 22.5em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
	padding-left: 24em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
	padding-left: 25.5em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
	padding-right: 24em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
	padding-right: 25.5em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
	padding-left: 27em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
	padding-left: 28.5em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
	padding-right: 27em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
	padding-right: 28.5em;
}
.ql-editor li.ql-direction-rtl {
	padding-right: 1.5em;
}
.ql-editor li.ql-direction-rtl > .ql-ui:before {
	margin-left: 0.3em;
	margin-right: -1.5em;
	text-align: left;
}
.ql-editor table {
	table-layout: fixed;
	width: 100%;
}
.ql-editor table td {
	outline: none;
}
.ql-editor .ql-code-block-container {
	font-family: monospace;
}
.ql-editor .ql-video {
	display: block;
	max-width: 100%;
}
.ql-editor .ql-video.ql-align-center {
	margin: 0 auto;
}
.ql-editor .ql-video.ql-align-right {
	margin: 0 0 0 auto;
}
.ql-editor .ql-bg-black {
	background-color: #000;
}
.ql-editor .ql-bg-red {
	background-color: #e60000;
}
.ql-editor .ql-bg-orange {
	background-color: #f90;
}
.ql-editor .ql-bg-yellow {
	background-color: #ff0;
}
.ql-editor .ql-bg-green {
	background-color: #008a00;
}
.ql-editor .ql-bg-blue {
	background-color: #06c;
}
.ql-editor .ql-bg-purple {
	background-color: #93f;
}
.ql-editor .ql-color-white {
	color: #fff;
}
.ql-editor .ql-color-red {
	color: #e60000;
}
.ql-editor .ql-color-orange {
	color: #f90;
}
.ql-editor .ql-color-yellow {
	color: #ff0;
}
.ql-editor .ql-color-green {
	color: #008a00;
}
.ql-editor .ql-color-blue {
	color: #06c;
}
.ql-editor .ql-color-purple {
	color: #93f;
}
.ql-editor .ql-font-serif {
	font-family: Georgia, Times New Roman, serif;
}
.ql-editor .ql-font-monospace {
	font-family: Monaco, Courier New, monospace;
}
.ql-editor .ql-size-small {
	font-size: 0.75em;
}
.ql-editor .ql-size-large {
	font-size: 1.5em;
}
.ql-editor .ql-size-huge {
	font-size: 2.5em;
}
.ql-editor .ql-direction-rtl {
	direction: rtl;
	text-align: inherit;
}
.ql-editor .ql-align-center {
	text-align: center;
}
.ql-editor .ql-align-justify {
	text-align: justify;
}
.ql-editor .ql-align-right {
	text-align: right;
}
.ql-editor .ql-ui {
	position: absolute;
}
.ql-editor.ql-blank::before {
	color: rgba(0, 0, 0, 0.6);
	content: attr(data-placeholder);
	font-style: italic;
	left: 15px;
	pointer-events: none;
	position: absolute;
	right: 15px;
}
.ql-bubble.ql-toolbar:after,
.ql-bubble .ql-toolbar:after {
	clear: both;
	content: '';
	display: table;
}
.ql-bubble.ql-toolbar button,
.ql-bubble .ql-toolbar button {
	background: none;
	border: none;
	cursor: pointer;
	display: inline-block;
	float: left;
	height: 24px;
	padding: 3px 5px;
	width: 28px;
}
.ql-bubble.ql-toolbar button svg,
.ql-bubble .ql-toolbar button svg {
	float: left;
	height: 100%;
}
.ql-bubble.ql-toolbar button:active:hover,
.ql-bubble .ql-toolbar button:active:hover {
	outline: none;
}
.ql-bubble.ql-toolbar input.ql-image[type='file'],
.ql-bubble .ql-toolbar input.ql-image[type='file'] {
	display: none;
}
.ql-bubble.ql-toolbar button:hover,
.ql-bubble .ql-toolbar button:hover,
.ql-bubble.ql-toolbar button:focus,
.ql-bubble .ql-toolbar button:focus,
.ql-bubble.ql-toolbar button.ql-active,
.ql-bubble .ql-toolbar button.ql-active,
.ql-bubble.ql-toolbar .ql-picker-label:hover,
.ql-bubble .ql-toolbar .ql-picker-label:hover,
.ql-bubble.ql-toolbar .ql-picker-label.ql-active,
.ql-bubble .ql-toolbar .ql-picker-label.ql-active,
.ql-bubble.ql-toolbar .ql-picker-item:hover,
.ql-bubble .ql-toolbar .ql-picker-item:hover,
.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,
.ql-bubble .ql-toolbar .ql-picker-item.ql-selected {
	color: #fff;
}
.ql-bubble.ql-toolbar button:hover .ql-fill,
.ql-bubble .ql-toolbar button:hover .ql-fill,
.ql-bubble.ql-toolbar button:focus .ql-fill,
.ql-bubble .ql-toolbar button:focus .ql-fill,
.ql-bubble.ql-toolbar button.ql-active .ql-fill,
.ql-bubble .ql-toolbar button.ql-active .ql-fill,
.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
	fill: #fff;
}
.ql-bubble.ql-toolbar button:hover .ql-stroke,
.ql-bubble .ql-toolbar button:hover .ql-stroke,
.ql-bubble.ql-toolbar button:focus .ql-stroke,
.ql-bubble .ql-toolbar button:focus .ql-stroke,
.ql-bubble.ql-toolbar button.ql-active .ql-stroke,
.ql-bubble .ql-toolbar button.ql-active .ql-stroke,
.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,
.ql-bubble .ql-toolbar button:hover .ql-stroke-miter,
.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,
.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,
.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
	stroke: #fff;
}
@media (pointer: coarse) {
	.ql-bubble.ql-toolbar button:hover:not(.ql-active),
	.ql-bubble .ql-toolbar button:hover:not(.ql-active) {
		color: #ccc;
	}
	.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,
	.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,
	.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
	.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
		fill: #ccc;
	}
	.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
	.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
	.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
	.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
		stroke: #ccc;
	}
}
.ql-bubble {
	box-sizing: border-box;
}
.ql-bubble * {
	box-sizing: border-box;
}
.ql-bubble .ql-hidden {
	display: none;
}
.ql-bubble .ql-out-bottom,
.ql-bubble .ql-out-top {
	visibility: hidden;
}

.ql-bubble .ql-tooltip {
	position: absolute;
	transform: translateY(10px);
	z-index: 1;
}
.ql-bubble .ql-tooltip a {
	cursor: pointer;
	text-decoration: none;
}
.ql-bubble .ql-tooltip.ql-flip {
	transform: translateY(-10px);
}
.ql-bubble .ql-formats {
	display: inline-block;
	vertical-align: middle;
}
.ql-bubble .ql-formats:after {
	clear: both;
	content: '';
	display: table;
}
.ql-bubble .ql-stroke {
	fill: none;
	stroke: #ccc;
	stroke-linecap: round;
	stroke-linejoin: round;
	stroke-width: 2;
}
.ql-bubble .ql-stroke-miter {
	fill: none;
	stroke: #ccc;
	stroke-miterlimit: 10;
	stroke-width: 2;
}
.ql-bubble .ql-fill,
.ql-bubble .ql-stroke.ql-fill {
	fill: #ccc;
}
.ql-bubble .ql-empty {
	fill: none;
}
.ql-bubble .ql-even {
	fill-rule: evenodd;
}
.ql-bubble .ql-thin,
.ql-bubble .ql-stroke.ql-thin {
	stroke-width: 1;
}
.ql-bubble .ql-transparent {
	opacity: 0.4;
}
.ql-bubble .ql-direction svg:last-child {
	display: none;
}
.ql-bubble .ql-direction.ql-active svg:last-child {
	display: inline;
}
.ql-bubble .ql-direction.ql-active svg:first-child {
	display: none;
}
.ql-bubble .ql-editor h1 {
	font-size: 2em;
}
.ql-bubble .ql-editor h2 {
	font-size: 1.5em;
}
.ql-bubble .ql-editor h3 {
	font-size: 1.17em;
}
.ql-bubble .ql-editor h4 {
	font-size: 1em;
}
.ql-bubble .ql-editor h5 {
	font-size: 0.83em;
}
.ql-bubble .ql-editor h6 {
	font-size: 0.67em;
}
.ql-bubble .ql-editor a {
	text-decoration: underline;
}
.ql-bubble .ql-editor blockquote {
	border-left: 4px solid #ccc;
	margin-bottom: 5px;
	margin-top: 5px;
	padding-left: 16px;
}
.ql-bubble .ql-editor code,
.ql-bubble .ql-editor .ql-code-block-container {
	background-color: #f0f0f0;
	border-radius: 3px;
}
.ql-bubble .ql-editor .ql-code-block-container {
	margin-bottom: 5px;
	margin-top: 5px;
	padding: 5px 10px;
}
.ql-bubble .ql-editor code {
	font-size: 85%;
	padding: 2px 4px;
}
.ql-bubble .ql-editor .ql-code-block-container {
	background-color: #23241f;
	color: #f8f8f2;
	overflow: visible;
}
.ql-bubble .ql-editor img {
	max-width: 100%;
}
.ql-bubble .ql-picker {
	color: #ccc;
	display: inline-block;
	float: left;
	font-size: 14px;
	font-weight: 500;
	height: 24px;
	position: relative;
	vertical-align: middle;
}
.ql-bubble .ql-picker-label {
	cursor: pointer;
	display: inline-block;
	height: 100%;
	padding-left: 8px;
	padding-right: 2px;
	position: relative;
	width: 100%;
}
.ql-bubble .ql-picker-label::before {
	display: inline-block;
	line-height: 22px;
}
.ql-bubble .ql-picker-options {
	background-color: #444;
	display: none;
	min-width: 100%;
	padding: 4px 8px;
	position: absolute;
	white-space: nowrap;
}
.ql-bubble .ql-picker-options .ql-picker-item {
	cursor: pointer;
	display: block;
	padding-bottom: 5px;
	padding-top: 5px;
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-label {
	color: #777;
	z-index: 2;
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill {
	fill: #777;
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
	stroke: #777;
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-options {
	display: block;
	margin-top: -1px;
	top: 100%;
	z-index: 1;
}
.ql-bubble .ql-color-picker,
.ql-bubble .ql-icon-picker {
	width: 28px;
}
.ql-bubble .ql-color-picker .ql-picker-label,
.ql-bubble .ql-icon-picker .ql-picker-label {
	padding: 2px 4px;
}
.ql-bubble .ql-color-picker .ql-picker-label svg,
.ql-bubble .ql-icon-picker .ql-picker-label svg {
	right: 4px;
}
.ql-bubble .ql-icon-picker .ql-picker-options {
	padding: 4px 0;
}
.ql-bubble .ql-icon-picker .ql-picker-item {
	height: 24px;
	width: 24px;
	padding: 2px 4px;
}
.ql-bubble .ql-color-picker .ql-picker-options {
	padding: 3px 5px;
	width: 152px;
}
.ql-bubble .ql-color-picker .ql-picker-item {
	border: 1px solid transparent;
	float: left;
	height: 16px;
	margin: 2px;
	padding: 0;
	width: 16px;
}
.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
	position: absolute;
	margin-top: -9px;
	right: 0;
	top: 50%;
	width: 18px;
}
.ql-bubble
	.ql-picker.ql-header
	.ql-picker-label[data-label]:not([data-label=''])::before,
.ql-bubble
	.ql-picker.ql-font
	.ql-picker-label[data-label]:not([data-label=''])::before,
.ql-bubble
	.ql-picker.ql-size
	.ql-picker-label[data-label]:not([data-label=''])::before,
.ql-bubble
	.ql-picker.ql-header
	.ql-picker-item[data-label]:not([data-label=''])::before,
.ql-bubble
	.ql-picker.ql-font
	.ql-picker-item[data-label]:not([data-label=''])::before,
.ql-bubble
	.ql-picker.ql-size
	.ql-picker-item[data-label]:not([data-label=''])::before {
	content: attr(data-label);
}
.ql-bubble .ql-picker.ql-header {
	width: 98px;
}
.ql-bubble .ql-picker.ql-header .ql-picker-label::before,
.ql-bubble .ql-picker.ql-header .ql-picker-item::before {
	content: 'Normal';
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
	content: 'Heading 1';
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
	content: 'Heading 2';
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
	content: 'Heading 3';
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
	content: 'Heading 4';
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
	content: 'Heading 5';
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
	content: 'Heading 6';
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
	font-size: 2em;
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
	font-size: 1.5em;
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
	font-size: 1.17em;
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
	font-size: 1em;
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
	font-size: 0.83em;
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
	font-size: 0.67em;
}
.ql-bubble .ql-picker.ql-font {
	width: 108px;
}
.ql-bubble .ql-picker.ql-font .ql-picker-label::before,
.ql-bubble .ql-picker.ql-font .ql-picker-item::before {
	content: 'Sans Serif';
}
.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
	content: 'Serif';
}
.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
	content: 'Monospace';
}
.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
	font-family: Georgia, Times New Roman, serif;
}
.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
	font-family: Monaco, Courier New, monospace;
}
.ql-bubble .ql-picker.ql-size {
	width: 98px;
}
.ql-bubble .ql-picker.ql-size .ql-picker-label::before,
.ql-bubble .ql-picker.ql-size .ql-picker-item::before {
	content: 'Normal';
}
.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
	content: 'Small';
}
.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
	content: 'Large';
}
.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
	content: 'Huge';
}
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
	font-size: 10px;
}
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
	font-size: 18px;
}
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
	font-size: 32px;
}
.ql-bubble .ql-color-picker.ql-background .ql-picker-item {
	background-color: #fff;
}
.ql-bubble .ql-color-picker.ql-color .ql-picker-item {
	background-color: #000;
}
.ql-code-block-container {
	position: relative;
}
.ql-code-block-container .ql-ui {
	right: 5px;
	top: 5px;
}
.ql-bubble .ql-toolbar .ql-formats {
	margin: 8px 12px 8px 0;
}
.ql-bubble .ql-toolbar .ql-formats:first-child {
	margin-left: 12px;
}
.ql-bubble .ql-color-picker svg {
	margin: 1px;
}
.ql-bubble .ql-color-picker .ql-picker-item.ql-selected,
.ql-bubble .ql-color-picker .ql-picker-item:hover {
	border-color: #fff;
}
.ql-bubble .ql-tooltip {
	background-color: #444;
	border-radius: 25px;
	color: #fff;
}
.ql-bubble .ql-tooltip-arrow {
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	content: ' ';
	display: block;
	left: 50%;
	margin-left: -6px;
	position: absolute;
}
.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow {
	border-bottom: 6px solid #444;
	top: -6px;
}
.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow {
	border-top: 6px solid #444;
	bottom: -6px;
}
.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor {
	display: block;
}
.ql-bubble .ql-tooltip.ql-editing .ql-formats {
	visibility: hidden;
}
.ql-bubble .ql-tooltip-editor {
	display: none;
}
.ql-bubble .ql-tooltip-editor input[type='text'] {
	background: transparent;
	border: none;
	color: #fff;
	font-size: 13px;
	height: 100%;
	outline: none;
	padding: 10px 20px;
	position: absolute;
	width: 100%;
}
.ql-bubble .ql-tooltip-editor a {
	top: 10px;
	position: absolute;
	right: 20px;
}
.ql-bubble .ql-tooltip-editor a:before {
	color: #ccc;
	content: '\\00D7';
	font-size: 16px;
	font-weight: bold;
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close) {
	position: relative;
	white-space: nowrap;
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before {
	background-color: #444;
	border-radius: 15px;
	top: -5px;
	font-size: 12px;
	color: #fff;
	content: attr(href);
	font-weight: normal;
	overflow: hidden;
	padding: 5px 15px;
	text-decoration: none;
	z-index: 1;
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after {
	border-top: 6px solid #444;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	top: 0;
	content: ' ';
	height: 0;
	width: 0;
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before,
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after {
	left: 0;
	margin-left: 50%;
	position: absolute;
	transform: translate(-50%, -100%);
	transition: visibility 0s ease 200ms;
	visibility: hidden;
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::before,
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::after {
	visibility: visible;
}

.qlbt-operation-menu {
	z-index: 2001 !important;
}

/* src/components/contract-editor/html-block/html-block.css */
.highlight-green {
	background-color: #e3fbc8;
	border-radius: 4px;
	transition: background-color 0.5s ease;
}

.highlight-transparent {
	background-color: transparent;
	border-radius: 4px;
	transition: background-color 0.5s ease;
}

.highlight-red {
	background-color: #f9cac9;
	border-radius: 4px;
	transition: background-color 0.5s ease;
}

.fade-out {
	animation: fadeOut 0.5s forwards; /* Анимация исчезновения */
	opacity: 0;
}

.fade-in {
	animation: fadeIn 0.5s forwards; /* Анимация появления */
	opacity: 1;
}

@keyframes fadeOut {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/contract-editor/contract-editor.css"],"names":[],"mappings":"AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,mBAAmB;AACpB;;AAEA;;CAEC,yBAAyB;CACzB,kBAAkB;CAClB;yBACwB;AACzB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;;;;;CAKC,oBAAoB;AACrB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,eAAe;CACf,aAAa;CACb,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,aAAa;CACb,SAAS;CACT,QAAQ;AACT;;AAEA;;;;;;CAMC,kBAAkB;CAClB,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,sBAAsB;CACtB,yCAAyC;CACzC,eAAe;CACf,YAAY;CACZ,SAAS;CACT,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;;CAEC,eAAe;AAChB;AACA;CACC,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;AACT;AACA;CACC,SAAS;CACT,UAAU;AACX;AACA;CACC,sBAAsB;CACtB;QACO;CACP,iBAAiB;CACjB,YAAY;CACZ,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,qBAAqB;AACtB;AACA;;;;;;;;;;CAUC,SAAS;CACT,UAAU;AACX;;AAEA;CACC;;;;;;;EAOC;SACO;CACR;AACD;AACA;CACC;;;;;;;EAOC;gBACc;CACf;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sBAAsB;CACtB,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;CACnB,YAAY;AACb;AACA;;CAEC,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC;EACC,2EAA2E;CAC5E;AACD;AACA;CACC;EACC;SACO;CACR;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sCAAsC;AACvC;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC;EACC,oEAAoE;CACrE;AACD;AACA;CACC;EACC,sEAAsE;CACvE;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC;EACC,6DAA6D;CAC9D;AACD;AACA;CACC;EACC,+DAA+D;CAChE;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sCAAsC;AACvC;AACA;CACC;EACC,sDAAsD;CACvD;AACD;AACA;CACC;EACC,wDAAwD;CACzD;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC;EACC,+CAA+C;CAChD;AACD;AACA;CACC;EACC,iDAAiD;CAClD;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC;EACC,wCAAwC;CACzC;AACD;AACA;CACC;EACC,0CAA0C;CAC3C;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sCAAsC;AACvC;AACA;CACC;EACC,iCAAiC;CAClC;AACD;AACA;CACC;EACC,mCAAmC;CACpC;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC;EACC,0BAA0B;CAC3B;AACD;AACA;CACC;EACC,4BAA4B;CAC7B;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC;EACC,mBAAmB;CACpB;AACD;AACA;CACC;EACC,qBAAqB;CACtB;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sCAAsC;AACvC;AACA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,gBAAgB;AACjB;AACA;CACC,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,sBAAsB;AACvB;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,2CAA2C;AAC5C;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,+BAA+B;CAC/B,kBAAkB;CAClB,UAAU;CACV,oBAAoB;CACpB,kBAAkB;CAClB,WAAW;AACZ;AACA;;CAEC,WAAW;CACX,WAAW;CACX,cAAc;AACf;AACA;;CAEC,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,WAAW;AACZ;AACA;;CAEC,WAAW;CACX,YAAY;AACb;AACA;;CAEC,aAAa;AACd;AACA;;CAEC,aAAa;AACd;AACA;;;;;;;;;;;;;;CAcC,WAAW;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC,UAAU;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC,YAAY;AACb;AACA;CACC;;EAEC,WAAW;CACZ;CACA;;;;EAIC,UAAU;CACX;CACA;;;;EAIC,YAAY;CACb;AACD;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,aAAa;AACd;AACA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,UAAU;AACX;AACA;CACC,eAAe;CACf,qBAAqB;AACtB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;AACA;CACC,WAAW;CACX,WAAW;CACX,cAAc;AACf;AACA;CACC,UAAU;CACV,YAAY;CACZ,qBAAqB;CACrB,sBAAsB;CACtB,eAAe;AAChB;AACA;CACC,UAAU;CACV,YAAY;CACZ,qBAAqB;CACrB,eAAe;AAChB;AACA;;CAEC,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;AACA;;CAEC,eAAe;AAChB;AACA;CACC,YAAY;AACb;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,2BAA2B;CAC3B,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;AACA;;CAEC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;CACX,qBAAqB;CACrB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,sBAAsB;AACvB;AACA;CACC,eAAe;CACf,qBAAqB;CACrB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;AACA;CACC,sBAAsB;CACtB,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,YAAY;AACb;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;AACA;;CAEC,WAAW;AACZ;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,6BAA6B;CAC7B,WAAW;CACX,YAAY;CACZ,WAAW;CACX,UAAU;CACV,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,QAAQ;CACR,QAAQ;CACR,WAAW;AACZ;AACA;;;;;;;;;;;;;;;;;;CAkBC,yBAAyB;AAC1B;AACA;CACC,WAAW;AACZ;AACA;;CAEC,iBAAiB;AAClB;AACA;;CAEC,oBAAoB;AACrB;AACA;;CAEC,oBAAoB;AACrB;AACA;;CAEC,oBAAoB;AACrB;AACA;;CAEC,oBAAoB;AACrB;AACA;;CAEC,oBAAoB;AACrB;AACA;;CAEC,oBAAoB;AACrB;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,YAAY;AACb;AACA;;CAEC,qBAAqB;AACtB;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,oBAAoB;AACrB;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,2CAA2C;AAC5C;AACA;CACC,WAAW;AACZ;AACA;;CAEC,iBAAiB;AAClB;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,UAAU;CACV,QAAQ;AACT;AACA;CACC,sBAAsB;AACvB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;AACA;;CAEC,kBAAkB;AACnB;AACA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,kCAAkC;CAClC,mCAAmC;CACnC,YAAY;CACZ,cAAc;CACd,SAAS;CACT,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,SAAS;AACV;AACA;CACC,0BAA0B;CAC1B,YAAY;AACb;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,uBAAuB;CACvB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,SAAS;CACT,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,UAAU;AACX;AACA;CACC,0BAA0B;CAC1B,kCAAkC;CAClC,mCAAmC;CACnC,MAAM;CACN,YAAY;CACZ,SAAS;CACT,QAAQ;AACT;AACA;;CAEC,OAAO;CACP,gBAAgB;CAChB,kBAAkB;CAClB,iCAAiC;CACjC,oCAAoC;CACpC,kBAAkB;AACnB;AACA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;AACzB;;AAEA,6DAA6D;AAC7D;CACC,yBAAyB;CACzB,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;CAC7B,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,gCAAgC,EAAE,0BAA0B;CAC5D,UAAU;AACX;;AAEA;CACC,+BAA+B,EAAE,uBAAuB;CACxD,UAAU;AACX;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n.ql-bubble {\n\tborder: 1px solid #303030;\n\tborder-radius: 8px;\n}\n\n.ql-editor {\n    font-size: 16px !important;\n}\n\n.ant-segmented-group {\n\tdisplay: inline-flex;\n\tflex-wrap: wrap;\n\tflex-direction: row;\n}\n\n.ql-container.ql-snow,\n.ql-container.ql-bubble {\n\tborder: 0px solid #303030;\n\tborder-radius: 8px;\n\t/* overflow-y: auto;\n    max-height: 1000px; */\n}\n\n.ql-toolbar.ql-snow {\n\tborder: 0px solid #303030;\n\tborder-radius: 8px;\n}\n\n.ql-editor p {\n\tmargin: 12px 0 !important;\n\tfont-family: 'Inter';\n}\n\n.ql-editor {\n\tline-height: 1.5 !important;\n}\n\n.ql-editor li {\n\tmargin: 12px 0 !important;\n\tfont-family: 'Inter';\n}\n\n.ql-editor h1,\nh2,\nh3,\nh4,\nh5 {\n\tfont-family: 'Inter';\n}\n\n.ql-container {\n\tfont-size: 16px !important;\n}\n\n.ql-smart-field {\n\tborder-radius: 4px;\n\tbackground-color: rgba(0, 97, 0, 0);\n}\n\ntable.quill-better-table td {\n\tborder: 1px solid #444;\n}\n.ql-clipboard {\n\tposition: fixed;\n\tdisplay: none;\n\tleft: 50%;\n\ttop: 50%;\n}\n\ntable.quill-better-table td {\n\tborder: 1px solid #cccccc;\n\tbackground-color: #fafafa;\n}\n\n.ql-clipboard {\n\tposition: fixed;\n\tdisplay: none;\n\tleft: 50%;\n\ttop: 50%;\n}\n\n[class^='placeholderClass'],\n[class^='dateClass'],\n[class^='fullnameClass'],\n[class^='emailClass'],\n[class^='signClass'],\n[class^='initialsClass'] {\n\tborder-radius: 4px;\n\tborder: 1px solid #d0e0c7;\n\tcolor: black;\n}\n\n.ant-space-item:has(> #contractActionsFooter) {\n\tbottom: 8px;\n\tposition: sticky;\n\tz-index: 1000;\n}\n\n.qlbt-operation-menu {\n\tz-index: 2001 !important;\n}\n\n.ql-container {\n\tbox-sizing: border-box;\n\tfont-family: Helvetica, Arial, sans-serif;\n\tfont-size: 13px;\n\theight: 100%;\n\tmargin: 0;\n\tposition: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n\tvisibility: hidden;\n}\n.ql-container:not(.ql-disabled) li[data-list='checked'] > .ql-ui,\n.ql-container:not(.ql-disabled) li[data-list='unchecked'] > .ql-ui {\n\tcursor: pointer;\n}\n.ql-clipboard {\n\tleft: -100000px;\n\theight: 1px;\n\toverflow-y: hidden;\n\tposition: absolute;\n\ttop: 50%;\n}\n.ql-clipboard p {\n\tmargin: 0;\n\tpadding: 0;\n}\n.ql-editor {\n\tbox-sizing: border-box;\n\tcounter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8\n\t\tlist-9;\n\tline-height: 1.42;\n\theight: 100%;\n\toutline: none;\n\toverflow-y: auto;\n\tpadding: 12px 15px;\n\ttab-size: 4;\n\t-moz-tab-size: 4;\n\ttext-align: left;\n\twhite-space: pre-wrap;\n\tword-wrap: break-word;\n}\n.ql-editor > * {\n\tcursor: text;\n\twhite-space: pre-wrap;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n\tmargin: 0;\n\tpadding: 0;\n}\n\n@supports (counter-set: none) {\n\t.ql-editor p,\n\t.ql-editor h1,\n\t.ql-editor h2,\n\t.ql-editor h3,\n\t.ql-editor h4,\n\t.ql-editor h5,\n\t.ql-editor h6 {\n\t\tcounter-set: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8\n\t\t\tlist-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor p,\n\t.ql-editor h1,\n\t.ql-editor h2,\n\t.ql-editor h3,\n\t.ql-editor h4,\n\t.ql-editor h5,\n\t.ql-editor h6 {\n\t\tcounter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7\n\t\t\tlist-8 list-9;\n\t}\n}\n.ql-editor table {\n\tborder-collapse: collapse;\n}\n.ql-editor td {\n\tborder: 1px solid #000;\n\tpadding: 2px 5px;\n}\n.ql-editor ol {\n\tpadding-left: 1.5em;\n}\n.ql-editor li {\n\tlist-style-type: none;\n\tpadding-left: 1.5em;\n\tposition: relative;\n}\n.ql-editor li > .ql-ui:before {\n\tdisplay: inline-block;\n\tmargin-left: -1.5em;\n\tmargin-right: 0.3em;\n\ttext-align: right;\n\twhite-space: nowrap;\n\twidth: 1.2em;\n}\n.ql-editor li[data-list='checked'] > .ql-ui,\n.ql-editor li[data-list='unchecked'] > .ql-ui {\n\tcolor: #777;\n}\n.ql-editor li[data-list='bullet'] > .ql-ui:before {\n\tcontent: '\\2022';\n}\n.ql-editor li[data-list='checked'] > .ql-ui:before {\n\tcontent: '\\2611';\n}\n.ql-editor li[data-list='unchecked'] > .ql-ui:before {\n\tcontent: '\\2610';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list] {\n\t\tcounter-set: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list] {\n\t\tcounter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8\n\t\t\tlist-9;\n\t}\n}\n.ql-editor li[data-list='ordered'] {\n\tcounter-increment: list-0;\n}\n.ql-editor li[data-list='ordered'] > .ql-ui:before {\n\tcontent: counter(list-0, decimal) '. ';\n}\n.ql-editor li[data-list='ordered'].ql-indent-1 {\n\tcounter-increment: list-1;\n}\n.ql-editor li[data-list='ordered'].ql-indent-1 > .ql-ui:before {\n\tcontent: counter(list-1, lower-alpha) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-1 {\n\t\tcounter-set: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-1 {\n\t\tcounter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-2 {\n\tcounter-increment: list-2;\n}\n.ql-editor li[data-list='ordered'].ql-indent-2 > .ql-ui:before {\n\tcontent: counter(list-2, lower-roman) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-2 {\n\t\tcounter-set: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-2 {\n\t\tcounter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-3 {\n\tcounter-increment: list-3;\n}\n.ql-editor li[data-list='ordered'].ql-indent-3 > .ql-ui:before {\n\tcontent: counter(list-3, decimal) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-3 {\n\t\tcounter-set: list-4 list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-3 {\n\t\tcounter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-4 {\n\tcounter-increment: list-4;\n}\n.ql-editor li[data-list='ordered'].ql-indent-4 > .ql-ui:before {\n\tcontent: counter(list-4, lower-alpha) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-4 {\n\t\tcounter-set: list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-4 {\n\t\tcounter-reset: list-5 list-6 list-7 list-8 list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-5 {\n\tcounter-increment: list-5;\n}\n.ql-editor li[data-list='ordered'].ql-indent-5 > .ql-ui:before {\n\tcontent: counter(list-5, lower-roman) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-5 {\n\t\tcounter-set: list-6 list-7 list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-5 {\n\t\tcounter-reset: list-6 list-7 list-8 list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-6 {\n\tcounter-increment: list-6;\n}\n.ql-editor li[data-list='ordered'].ql-indent-6 > .ql-ui:before {\n\tcontent: counter(list-6, decimal) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-6 {\n\t\tcounter-set: list-7 list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-6 {\n\t\tcounter-reset: list-7 list-8 list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-7 {\n\tcounter-increment: list-7;\n}\n.ql-editor li[data-list='ordered'].ql-indent-7 > .ql-ui:before {\n\tcontent: counter(list-7, lower-alpha) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-7 {\n\t\tcounter-set: list-8 list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-7 {\n\t\tcounter-reset: list-8 list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-8 {\n\tcounter-increment: list-8;\n}\n.ql-editor li[data-list='ordered'].ql-indent-8 > .ql-ui:before {\n\tcontent: counter(list-8, lower-roman) '. ';\n}\n@supports (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-8 {\n\t\tcounter-set: list-9;\n\t}\n}\n@supports not (counter-set: none) {\n\t.ql-editor li[data-list].ql-indent-8 {\n\t\tcounter-reset: list-9;\n\t}\n}\n.ql-editor li[data-list='ordered'].ql-indent-9 {\n\tcounter-increment: list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-9 > .ql-ui:before {\n\tcontent: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n\tpadding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n\tpadding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n\tpadding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n\tpadding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n\tpadding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n\tpadding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n\tpadding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n\tpadding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n\tpadding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n\tpadding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n\tpadding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n\tpadding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n\tpadding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n\tpadding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n\tpadding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n\tpadding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n\tpadding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n\tpadding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n\tpadding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n\tpadding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n\tpadding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n\tpadding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n\tpadding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n\tpadding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n\tpadding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n\tpadding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n\tpadding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n\tpadding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n\tpadding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n\tpadding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n\tpadding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n\tpadding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n\tpadding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n\tpadding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n\tpadding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n\tpadding-right: 28.5em;\n}\n.ql-editor li.ql-direction-rtl {\n\tpadding-right: 1.5em;\n}\n.ql-editor li.ql-direction-rtl > .ql-ui:before {\n\tmargin-left: 0.3em;\n\tmargin-right: -1.5em;\n\ttext-align: left;\n}\n.ql-editor table {\n\ttable-layout: fixed;\n\twidth: 100%;\n}\n.ql-editor table td {\n\toutline: none;\n}\n.ql-editor .ql-code-block-container {\n\tfont-family: monospace;\n}\n.ql-editor .ql-video {\n\tdisplay: block;\n\tmax-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n\tmargin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n\tmargin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n\tbackground-color: #000;\n}\n.ql-editor .ql-bg-red {\n\tbackground-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n\tbackground-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n\tbackground-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n\tbackground-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n\tbackground-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n\tbackground-color: #93f;\n}\n.ql-editor .ql-color-white {\n\tcolor: #fff;\n}\n.ql-editor .ql-color-red {\n\tcolor: #e60000;\n}\n.ql-editor .ql-color-orange {\n\tcolor: #f90;\n}\n.ql-editor .ql-color-yellow {\n\tcolor: #ff0;\n}\n.ql-editor .ql-color-green {\n\tcolor: #008a00;\n}\n.ql-editor .ql-color-blue {\n\tcolor: #06c;\n}\n.ql-editor .ql-color-purple {\n\tcolor: #93f;\n}\n.ql-editor .ql-font-serif {\n\tfont-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n\tfont-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n\tfont-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n\tfont-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n\tfont-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n\tdirection: rtl;\n\ttext-align: inherit;\n}\n.ql-editor .ql-align-center {\n\ttext-align: center;\n}\n.ql-editor .ql-align-justify {\n\ttext-align: justify;\n}\n.ql-editor .ql-align-right {\n\ttext-align: right;\n}\n.ql-editor .ql-ui {\n\tposition: absolute;\n}\n.ql-editor.ql-blank::before {\n\tcolor: rgba(0, 0, 0, 0.6);\n\tcontent: attr(data-placeholder);\n\tfont-style: italic;\n\tleft: 15px;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 15px;\n}\n.ql-bubble.ql-toolbar:after,\n.ql-bubble .ql-toolbar:after {\n\tclear: both;\n\tcontent: '';\n\tdisplay: table;\n}\n.ql-bubble.ql-toolbar button,\n.ql-bubble .ql-toolbar button {\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tfloat: left;\n\theight: 24px;\n\tpadding: 3px 5px;\n\twidth: 28px;\n}\n.ql-bubble.ql-toolbar button svg,\n.ql-bubble .ql-toolbar button svg {\n\tfloat: left;\n\theight: 100%;\n}\n.ql-bubble.ql-toolbar button:active:hover,\n.ql-bubble .ql-toolbar button:active:hover {\n\toutline: none;\n}\n.ql-bubble.ql-toolbar input.ql-image[type='file'],\n.ql-bubble .ql-toolbar input.ql-image[type='file'] {\n\tdisplay: none;\n}\n.ql-bubble.ql-toolbar button:hover,\n.ql-bubble .ql-toolbar button:hover,\n.ql-bubble.ql-toolbar button:focus,\n.ql-bubble .ql-toolbar button:focus,\n.ql-bubble.ql-toolbar button.ql-active,\n.ql-bubble .ql-toolbar button.ql-active,\n.ql-bubble.ql-toolbar .ql-picker-label:hover,\n.ql-bubble .ql-toolbar .ql-picker-label:hover,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active,\n.ql-bubble.ql-toolbar .ql-picker-item:hover,\n.ql-bubble .ql-toolbar .ql-picker-item:hover,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected {\n\tcolor: #fff;\n}\n.ql-bubble.ql-toolbar button:hover .ql-fill,\n.ql-bubble .ql-toolbar button:hover .ql-fill,\n.ql-bubble.ql-toolbar button:focus .ql-fill,\n.ql-bubble .ql-toolbar button:focus .ql-fill,\n.ql-bubble.ql-toolbar button.ql-active .ql-fill,\n.ql-bubble .ql-toolbar button.ql-active .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n\tfill: #fff;\n}\n.ql-bubble.ql-toolbar button:hover .ql-stroke,\n.ql-bubble .ql-toolbar button:hover .ql-stroke,\n.ql-bubble.ql-toolbar button:focus .ql-stroke,\n.ql-bubble .ql-toolbar button:focus .ql-stroke,\n.ql-bubble.ql-toolbar button.ql-active .ql-stroke,\n.ql-bubble .ql-toolbar button.ql-active .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,\n.ql-bubble .ql-toolbar button:hover .ql-stroke-miter,\n.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,\n.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,\n.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n\tstroke: #fff;\n}\n@media (pointer: coarse) {\n\t.ql-bubble.ql-toolbar button:hover:not(.ql-active),\n\t.ql-bubble .ql-toolbar button:hover:not(.ql-active) {\n\t\tcolor: #ccc;\n\t}\n\t.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n\t.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n\t.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n\t.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n\t\tfill: #ccc;\n\t}\n\t.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n\t.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n\t.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n\t.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n\t\tstroke: #ccc;\n\t}\n}\n.ql-bubble {\n\tbox-sizing: border-box;\n}\n.ql-bubble * {\n\tbox-sizing: border-box;\n}\n.ql-bubble .ql-hidden {\n\tdisplay: none;\n}\n.ql-bubble .ql-out-bottom,\n.ql-bubble .ql-out-top {\n\tvisibility: hidden;\n}\n\n.ql-bubble .ql-tooltip {\n\tposition: absolute;\n\ttransform: translateY(10px);\n\tz-index: 1;\n}\n.ql-bubble .ql-tooltip a {\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n.ql-bubble .ql-tooltip.ql-flip {\n\ttransform: translateY(-10px);\n}\n.ql-bubble .ql-formats {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n.ql-bubble .ql-formats:after {\n\tclear: both;\n\tcontent: '';\n\tdisplay: table;\n}\n.ql-bubble .ql-stroke {\n\tfill: none;\n\tstroke: #ccc;\n\tstroke-linecap: round;\n\tstroke-linejoin: round;\n\tstroke-width: 2;\n}\n.ql-bubble .ql-stroke-miter {\n\tfill: none;\n\tstroke: #ccc;\n\tstroke-miterlimit: 10;\n\tstroke-width: 2;\n}\n.ql-bubble .ql-fill,\n.ql-bubble .ql-stroke.ql-fill {\n\tfill: #ccc;\n}\n.ql-bubble .ql-empty {\n\tfill: none;\n}\n.ql-bubble .ql-even {\n\tfill-rule: evenodd;\n}\n.ql-bubble .ql-thin,\n.ql-bubble .ql-stroke.ql-thin {\n\tstroke-width: 1;\n}\n.ql-bubble .ql-transparent {\n\topacity: 0.4;\n}\n.ql-bubble .ql-direction svg:last-child {\n\tdisplay: none;\n}\n.ql-bubble .ql-direction.ql-active svg:last-child {\n\tdisplay: inline;\n}\n.ql-bubble .ql-direction.ql-active svg:first-child {\n\tdisplay: none;\n}\n.ql-bubble .ql-editor h1 {\n\tfont-size: 2em;\n}\n.ql-bubble .ql-editor h2 {\n\tfont-size: 1.5em;\n}\n.ql-bubble .ql-editor h3 {\n\tfont-size: 1.17em;\n}\n.ql-bubble .ql-editor h4 {\n\tfont-size: 1em;\n}\n.ql-bubble .ql-editor h5 {\n\tfont-size: 0.83em;\n}\n.ql-bubble .ql-editor h6 {\n\tfont-size: 0.67em;\n}\n.ql-bubble .ql-editor a {\n\ttext-decoration: underline;\n}\n.ql-bubble .ql-editor blockquote {\n\tborder-left: 4px solid #ccc;\n\tmargin-bottom: 5px;\n\tmargin-top: 5px;\n\tpadding-left: 16px;\n}\n.ql-bubble .ql-editor code,\n.ql-bubble .ql-editor .ql-code-block-container {\n\tbackground-color: #f0f0f0;\n\tborder-radius: 3px;\n}\n.ql-bubble .ql-editor .ql-code-block-container {\n\tmargin-bottom: 5px;\n\tmargin-top: 5px;\n\tpadding: 5px 10px;\n}\n.ql-bubble .ql-editor code {\n\tfont-size: 85%;\n\tpadding: 2px 4px;\n}\n.ql-bubble .ql-editor .ql-code-block-container {\n\tbackground-color: #23241f;\n\tcolor: #f8f8f2;\n\toverflow: visible;\n}\n.ql-bubble .ql-editor img {\n\tmax-width: 100%;\n}\n.ql-bubble .ql-picker {\n\tcolor: #ccc;\n\tdisplay: inline-block;\n\tfloat: left;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\theight: 24px;\n\tposition: relative;\n\tvertical-align: middle;\n}\n.ql-bubble .ql-picker-label {\n\tcursor: pointer;\n\tdisplay: inline-block;\n\theight: 100%;\n\tpadding-left: 8px;\n\tpadding-right: 2px;\n\tposition: relative;\n\twidth: 100%;\n}\n.ql-bubble .ql-picker-label::before {\n\tdisplay: inline-block;\n\tline-height: 22px;\n}\n.ql-bubble .ql-picker-options {\n\tbackground-color: #444;\n\tdisplay: none;\n\tmin-width: 100%;\n\tpadding: 4px 8px;\n\tposition: absolute;\n\twhite-space: nowrap;\n}\n.ql-bubble .ql-picker-options .ql-picker-item {\n\tcursor: pointer;\n\tdisplay: block;\n\tpadding-bottom: 5px;\n\tpadding-top: 5px;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label {\n\tcolor: #777;\n\tz-index: 2;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n\tfill: #777;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n\tstroke: #777;\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-options {\n\tdisplay: block;\n\tmargin-top: -1px;\n\ttop: 100%;\n\tz-index: 1;\n}\n.ql-bubble .ql-color-picker,\n.ql-bubble .ql-icon-picker {\n\twidth: 28px;\n}\n.ql-bubble .ql-color-picker .ql-picker-label,\n.ql-bubble .ql-icon-picker .ql-picker-label {\n\tpadding: 2px 4px;\n}\n.ql-bubble .ql-color-picker .ql-picker-label svg,\n.ql-bubble .ql-icon-picker .ql-picker-label svg {\n\tright: 4px;\n}\n.ql-bubble .ql-icon-picker .ql-picker-options {\n\tpadding: 4px 0;\n}\n.ql-bubble .ql-icon-picker .ql-picker-item {\n\theight: 24px;\n\twidth: 24px;\n\tpadding: 2px 4px;\n}\n.ql-bubble .ql-color-picker .ql-picker-options {\n\tpadding: 3px 5px;\n\twidth: 152px;\n}\n.ql-bubble .ql-color-picker .ql-picker-item {\n\tborder: 1px solid transparent;\n\tfloat: left;\n\theight: 16px;\n\tmargin: 2px;\n\tpadding: 0;\n\twidth: 16px;\n}\n.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n\tposition: absolute;\n\tmargin-top: -9px;\n\tright: 0;\n\ttop: 50%;\n\twidth: 18px;\n}\n.ql-bubble\n\t.ql-picker.ql-header\n\t.ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-bubble\n\t.ql-picker.ql-font\n\t.ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-bubble\n\t.ql-picker.ql-size\n\t.ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-bubble\n\t.ql-picker.ql-header\n\t.ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-bubble\n\t.ql-picker.ql-font\n\t.ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-bubble\n\t.ql-picker.ql-size\n\t.ql-picker-item[data-label]:not([data-label=''])::before {\n\tcontent: attr(data-label);\n}\n.ql-bubble .ql-picker.ql-header {\n\twidth: 98px;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item::before {\n\tcontent: 'Normal';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='1']::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n\tcontent: 'Heading 1';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='2']::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n\tcontent: 'Heading 2';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='3']::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n\tcontent: 'Heading 3';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='4']::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n\tcontent: 'Heading 4';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='5']::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n\tcontent: 'Heading 5';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value='6']::before,\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n\tcontent: 'Heading 6';\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n\tfont-size: 2em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n\tfont-size: 1.5em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n\tfont-size: 1.17em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n\tfont-size: 1em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n\tfont-size: 0.83em;\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n\tfont-size: 0.67em;\n}\n.ql-bubble .ql-picker.ql-font {\n\twidth: 108px;\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-item::before {\n\tcontent: 'Sans Serif';\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n\tcontent: 'Serif';\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n\tcontent: 'Monospace';\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n\tfont-family: Georgia, Times New Roman, serif;\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n\tfont-family: Monaco, Courier New, monospace;\n}\n.ql-bubble .ql-picker.ql-size {\n\twidth: 98px;\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item::before {\n\tcontent: 'Normal';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='small']::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n\tcontent: 'Small';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='large']::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n\tcontent: 'Large';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n\tcontent: 'Huge';\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n\tfont-size: 10px;\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n\tfont-size: 18px;\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n\tfont-size: 32px;\n}\n.ql-bubble .ql-color-picker.ql-background .ql-picker-item {\n\tbackground-color: #fff;\n}\n.ql-bubble .ql-color-picker.ql-color .ql-picker-item {\n\tbackground-color: #000;\n}\n.ql-code-block-container {\n\tposition: relative;\n}\n.ql-code-block-container .ql-ui {\n\tright: 5px;\n\ttop: 5px;\n}\n.ql-bubble .ql-toolbar .ql-formats {\n\tmargin: 8px 12px 8px 0;\n}\n.ql-bubble .ql-toolbar .ql-formats:first-child {\n\tmargin-left: 12px;\n}\n.ql-bubble .ql-color-picker svg {\n\tmargin: 1px;\n}\n.ql-bubble .ql-color-picker .ql-picker-item.ql-selected,\n.ql-bubble .ql-color-picker .ql-picker-item:hover {\n\tborder-color: #fff;\n}\n.ql-bubble .ql-tooltip {\n\tbackground-color: #444;\n\tborder-radius: 25px;\n\tcolor: #fff;\n}\n.ql-bubble .ql-tooltip-arrow {\n\tborder-left: 6px solid transparent;\n\tborder-right: 6px solid transparent;\n\tcontent: ' ';\n\tdisplay: block;\n\tleft: 50%;\n\tmargin-left: -6px;\n\tposition: absolute;\n}\n.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow {\n\tborder-bottom: 6px solid #444;\n\ttop: -6px;\n}\n.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow {\n\tborder-top: 6px solid #444;\n\tbottom: -6px;\n}\n.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor {\n\tdisplay: block;\n}\n.ql-bubble .ql-tooltip.ql-editing .ql-formats {\n\tvisibility: hidden;\n}\n.ql-bubble .ql-tooltip-editor {\n\tdisplay: none;\n}\n.ql-bubble .ql-tooltip-editor input[type='text'] {\n\tbackground: transparent;\n\tborder: none;\n\tcolor: #fff;\n\tfont-size: 13px;\n\theight: 100%;\n\toutline: none;\n\tpadding: 10px 20px;\n\tposition: absolute;\n\twidth: 100%;\n}\n.ql-bubble .ql-tooltip-editor a {\n\ttop: 10px;\n\tposition: absolute;\n\tright: 20px;\n}\n.ql-bubble .ql-tooltip-editor a:before {\n\tcolor: #ccc;\n\tcontent: '\\00D7';\n\tfont-size: 16px;\n\tfont-weight: bold;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close) {\n\tposition: relative;\n\twhite-space: nowrap;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before {\n\tbackground-color: #444;\n\tborder-radius: 15px;\n\ttop: -5px;\n\tfont-size: 12px;\n\tcolor: #fff;\n\tcontent: attr(href);\n\tfont-weight: normal;\n\toverflow: hidden;\n\tpadding: 5px 15px;\n\ttext-decoration: none;\n\tz-index: 1;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after {\n\tborder-top: 6px solid #444;\n\tborder-left: 6px solid transparent;\n\tborder-right: 6px solid transparent;\n\ttop: 0;\n\tcontent: ' ';\n\theight: 0;\n\twidth: 0;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before,\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after {\n\tleft: 0;\n\tmargin-left: 50%;\n\tposition: absolute;\n\ttransform: translate(-50%, -100%);\n\ttransition: visibility 0s ease 200ms;\n\tvisibility: hidden;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::before,\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::after {\n\tvisibility: visible;\n}\n\n.qlbt-operation-menu {\n\tz-index: 2001 !important;\n}\n\n/* src/components/contract-editor/html-block/html-block.css */\n.highlight-green {\n\tbackground-color: #e3fbc8;\n\tborder-radius: 4px;\n\ttransition: background-color 0.5s ease;\n}\n\n.highlight-transparent {\n\tbackground-color: transparent;\n\tborder-radius: 4px;\n\ttransition: background-color 0.5s ease;\n}\n\n.highlight-red {\n\tbackground-color: #f9cac9;\n\tborder-radius: 4px;\n\ttransition: background-color 0.5s ease;\n}\n\n.fade-out {\n\tanimation: fadeOut 0.5s forwards; /* Анимация исчезновения */\n\topacity: 0;\n}\n\n.fade-in {\n\tanimation: fadeIn 0.5s forwards; /* Анимация появления */\n\topacity: 1;\n}\n\n@keyframes fadeOut {\n\t0% {\n\t\topacity: 1;\n\t}\n\t100% {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes fadeIn {\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
